import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Carousel } from 'react-responsive-carousel';

import { closeSVG, logoHosmanPremiumSVG } from '../../../../assets/svgIcons';

import { removeProperty } from '../../../reducers/propertiesSlice';
import formattedNumber from '../../../../shared/helpers/format_number';


const PropertyCard = ({ property }) => {
  const { sharedByUser } = useSelector((state) => state.filters);
  const dispatch = useDispatch();

  // ------------------------------- CONSTRUCTOR -------------------------------
  const {
    pictures,
    street_name,
    city,
    zip_code,
    area,
    room_number,
    floor,
    dpe_energy_letter,
    sale,
    url,
    quarter_name,
    kind,
    approximate_location
  } = property;

  let tracked_url = sharedByUser ? `${url}?shared_by_user=${sharedByUser}` : url
  if (window.location.origin.includes('www') && !tracked_url.includes('www')) {
    tracked_url = tracked_url.replace('://', '://www.')
  }

  useEffect(() => {
    const carouselArrows = document.getElementsByClassName('control-arrow');
    [...carouselArrows].forEach((arrow) => {
      if (arrow.classList.contains('control-next')) {
        arrow.classList.add('carousel-button-next-white');
        arrow.insertAdjacentHTML('afterbegin', `<i class='fas fa-chevron-right'></i>`);
        arrow.classList.remove('control-next');
      } else if (arrow.classList.contains('control-prev')) {
        arrow.classList.add('carousel-button-prev-white');
        arrow.insertAdjacentHTML('afterbegin', `<i class='fas fa-chevron-left'></i>`);
        arrow.classList.remove('control-prev');
      }
      arrow.classList.remove('control-arrow');

      arrow.onclick = (event) => {
        event.preventDefault();
      };

      arrow.ondblclick = (event) => {
        event.preventDefault();
        event.stopPropagation();
      };
    });
  }, []);

  // ---------------------------- DISPLAY FUNCTIONS ----------------------------
  const displayAddress = () => {
    return (
      <div className='address'>
        <span>{formatAddress()}</span>
      </div>
    );
  };

  const formatAddress = () => {
    let city_info = ''

    if (quarter_name !== null && kind === 'house' && approximate_location) city_info = `${quarter_name} ${zip_code}`
    else if (street_name) city_info = `${street_name} ${zip_code}`
    else city_info = `${city} ${zip_code}`

    return city_info
  };

  const displayArrondissementParis = () => {
    if (city === 'Paris') {
      return zip_code.slice(-2);
    }
  }

  const displayFloor = (floor) => {
    if (!floor) return '';

    switch (floor) {
      case 0:
        return 'Rdc';
      case 1:
        return (
          <span>
            1<sup>er</sup> étage
          </span>
        );
      default:
        return (
          <span>
            {floor}
            <sup>e</sup>ét
          </span>
        );
    }
  };

  const handleClose = (e) => {
    e.preventDefault()
    dispatch(removeProperty())
  }

  // -------------------------------- MAIN VIEW --------------------------------
  return (
    <a
      href={tracked_url}
      target={ window.innerWidth > 768 ? '_blank' : '_self' }
      rel='noreferrer'
      className='vesta-margin-y-20'
      id='property-card-page'
    >
      <div className='vesta-sale-card' onClick={(e) => e.stopPropagation()}>
        <div className='vesta-close-card' onClick={handleClose}>
          {closeSVG("#FFFF")}
        </div>

        <Carousel
          showStatus={false}
          showIndicators={false}
          showThumbs={false}
          infiniteLoop
          emulateTouch
        >
          {pictures.map((picture) => (
            <div key={picture} className='vesta-image-wrapper'>
              <img
                src={picture}
                className='vesta-image property-photo'
                alt={`vente ${room_number} pièces ${area ? `de ${Math.round(area)} m²` : ''} à ${city}`}
              />
              <img
                src={pictures[1]}
                alt={`vente ${room_number} pièces ${area ? `de ${Math.round(area)} m²` : ''} à ${city}`}
                className='vesta-image-hover property-photo'
              />
            </div>
          ))}
        </Carousel>

        <img src={property.expert.photo}
             alt={`vente ${property.kind} de ${property.carrez_area} à ${property.city}`}
             className='expert-photo'
             loading='lazy'/>

        <div className="vesta-label-flex-container">
          <label className='vesta-label--indigo zone'>{city} {displayArrondissementParis()}</label>
        </div>

        <div className='vesta-flex-row-center vesta-gap-5 vesta-labels-container'>
          {sale.advert_label_sold &&
            <label className='vesta-label--green'>{sale.advert_label_sold}</label>
          }

          {dpe_energy_letter && ['A', 'B', 'C', 'D'].includes(dpe_energy_letter) &&
            <label className='vesta-label--green'>DPE {dpe_energy_letter}</label>
          }
        </div>

        <div className='description'>
          {displayAddress()}
          <div className='infos'>
            <span>{parseInt(area)}m²</span>
            <span>{room_number}p</span>
            <span>{displayFloor(floor)}</span>
          </div>
        </div>

        <div className='vesta-flex-col-center price'>
          <h4 className='typo-h4 vesta-text-center vesta-no-margin vesta-blue-100'>{sale.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} €</h4>

          <span className='typo-caption vesta-indigo-100'>
            {formattedNumber(property.advert_square_amount)} €/m²
          </span>
        </div>
      </div>
    </a>
  );
};

// PropTypes
PropertyCard.propTypes = {
  property: PropTypes.object.isRequired,
};

export default PropertyCard;
